import { render, staticRenderFns } from "./AddProductButton.vue?vue&type=template&id=58b1a615&"
import script from "./AddProductButton.vue?vue&type=script&lang=js&"
export * from "./AddProductButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports